import {
  AppState
} from 'helpers';

import {
  CacheKeys
} from '../../../constants';

import {
  Environment
} from '@vodacom/web-env';

export class FeedProvider {

  static BASE_URL = Environment.current.apiPath;
  static STATE = AppState.with('FeedProvider');

  static async getBatchFeeds(
    feedName,
    feedUrl,
    limit
  ) {

    const cachedItem = FeedProvider.getCachedItem(`batch--feeds--${feedName}`);

    if (!!cachedItem) {
      return cachedItem;
    }

    return FeedProvider.STATE.makeServiceCall(
      `${FeedProvider.BASE_URL}feed/batch`,
      {
        method: 'GET',
        queryParams: {
          'feeds': feedUrl,
          'limit': limit
        },
        cacheKey: `${CacheKeys.BatchRssFeeds}${feedName}`
      }
    )
      .then((res) => {
        if (!res.result || !Array.isArray(res.result) || !res.result.length) {
          return {
            ok: false,
            error: new Error('No batch feeds found'),
            trace: null,
            date: null,
            result: null,
            code: null,
            stamp: new Date()
          };
        }

        return res;
      })
      .catch((error) => {
        return {
          ok: false,
          error: error,
          trace: null,
          date: null,
          result: null,
          code: null,
          stamp: new Date()
        };
      });
  }

  static getFeedImage(
    imageId,
    feedName,
    feedCategory
  ) {

    const cachedItem = FeedProvider.getCachedItem(`${CacheKeys.FeedImage}${imageId}`);

    if (!!cachedItem) {
      return cachedItem;
    }

    return FeedProvider.STATE.makeServiceCall(
      `${FeedProvider.BASE_URL}feed/image/${imageId}`,
      {
        method: 'GET',
        queryParams: {
          'name': feedName,
          'category': feedCategory
        },
        cacheKey: `${CacheKeys.FeedImage}${imageId}`
      }
    )
      .then((res) => {
        if (!res?.ok || !res?.result) {
          return {
            ok: false,
            error: new Error('No image found'),
            trace: null,
            date: null,
            result: null,
            code: null,
            stamp: new Date()
          };
        }

        return res;
      })
      .catch((error) => {
        return {
          ok: false,
          error: error,
          trace: null,
          date: null,
          result: null,
          code: null,
          stamp: new Date()
        };
      });
  }

  static getCachedItem(key, fallback) {
    return FeedProvider.STATE.getItem(key, fallback);
  }
}
